import React, { useState, useEffect } from 'react';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import * as UI from '../constantes/UI.js';
import MensajeError from '../UI/MensajeError.js';

const SelectOrganizador = (props) => {
  const organizadorActual = props.organizadorActual;
  const incluirNulo = props.incluirNulo || false;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const { ITEM_COMBO_VACIO } = UI.useUI();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  // Función para obtener el valor mostrado de un organizador
  const getValorMostrado = (organizador) => {
    if (!organizador) return '';
    // Prioridad: nombreSimple si no es nulo, sino sigla
    return organizador.nombreSimple || organizador.sigla || '';
  };

  useEffect(() => {
    const setListaOrganizadores = (organizadores) => {
      // Crear lista con campo de descripción calculado
      const organizadoresConDescripcion = organizadores.map((org) => ({
        ...org,
        descripcionMostrada: getValorMostrado(org),
      }));

      if (incluirNulo) {
        setLista([
          {
            id: null,
            nombreSimple: ITEM_COMBO_VACIO,
            sigla: ITEM_COMBO_VACIO,
            descripcionMostrada: ITEM_COMBO_VACIO,
          },
          ...organizadoresConDescripcion,
        ]);
      } else {
        setLista(organizadoresConDescripcion);
      }
    };

    fetchData('organizadores_torneos', setListaOrganizadores);
  }, [fetchData, incluirNulo, ITEM_COMBO_VACIO]);

  const onItemElegido = (itemElegido) => {
    props.onOrganizadorElegido(itemElegido);
  };

  let valorActual = '';
  if (organizadorActual) {
    if (organizadorActual.nombreSimple || organizadorActual.sigla) {
      valorActual = getValorMostrado(organizadorActual);
    } else if (lista.length > 0) {
      for (const element of lista) {
        if (Number(element.id) === Number(organizadorActual.id)) {
          valorActual = getValorMostrado(element);
          break;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={valorActual}
        campoClave={TipoClave.ID}
        campoDescripcion="descripcionMostrada"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectOrganizador;
